<template>
  <v-container fluid grid-list-xl>
    <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
    <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
    <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
    <!-- ========================================================================================= -->
    <div v-responsive.lg.xl>
      <div>
        <!--PARITE MARQEE POUR LES LOGOS DES COMPAGNIES-->
        <div style="background: #fff;height: auto">
          <div class="justify-content-center column pt-5 mt-3 mb-5">
            <div class="justify-content-center row" v-if="$route.name !== 'assuraf_pro_online'">
              <h1 class="justify-content-center row titre_for_desktop">{{ $t('home_page.partenaires_title[0]') }}
                <br> {{ $t('home_page.partenaires_title[1]') }}</h1>
            </div>
            <div class="justify-content-center row" v-if="$route.name === 'assuraf_pro_online'">
              <h1 class="justify-content-center row titre_for_desktop">Ils nous font confiance</h1>
            </div>
            <div class="justify-content-center row">
              <v-toolbar class="justify-content-center row underline_bar"></v-toolbar>
            </div>

            <div class="slider" v-if="$route.name === 'assuraf_pro_online'">
              <div class="slide-track">
                <div class="slide" v-for="assure in listeAssureurs2" :key="assure._id">
                  <img :src="require(`@/assets/img/${assure.logoUrl}`)" :alt="assure.logoTitle" loading="lazy">
                </div>
                  <div class="slide" v-for="assure in listeAssureurs2" :key="assure._id">
                  <img :src="require(`@/assets/img/${assure.logoUrl}`)" :alt="assure.logoTitle" loading="lazy">
                </div>
              </div>
            </div>

            <div class="slider" v-if="$route.name !== 'assuraf_pro_online'">
              <div class="slide-track">
                    <div class="slide">
                      <img style="height: 60px; width: 180px!important;padding: 0px!important" src="../../assets/img/assureur/Logo_Sanlam_Allianz.png" alt="partenaire sanlamAllianz">
                    </div>
                <div class="slide" v-for="assure in listeAssureurs" :key="assure._id">
                  <img  :src="assure.logo" :alt="assure.societe">
                </div>
                    <div class="slide">
                      <img style="height: 60px; width: 180px!important;padding: 0px!important" src="../../assets/img/assureur/wafa.png" alt="partenaire wafa">
                    </div>
                     <div class="slide" v-for="assure in listeAssureurs" :key="assure._id">
                  <img  :src="assure.logo" :alt="assure.societe">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE      =============== -->
    <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
    <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
    <!-- ========================================================================================= -->
    <div style="margin-top:50px" v-responsive.sm.xs>
      <div>
        <!--PARITE MARQEE POUR LES LOGOS DES COMPAGNIES-->
        <div style="background: #fff;height:auto">
          <div class="justify-content-center column">
            <div class="justify-content-center row" v-if="$route.name !== 'assuraf_pro_online'">
              <h1 class="justify-content-center row titre_for_desktop"
                  style="font-size: 20px;padding-left: 20px!important;padding-right: 20px!important;">
                {{ $t('home_page.partenaires_title[0]') }} {{ $t('home_page.partenaires_title[1]') }}</h1>
            </div>
             <div class="justify-content-center row" v-if="$route.name === 'assuraf_pro_online'">
              <h1 class="justify-content-center row titre_for_desktop">Ils nous font confiance</h1>
            </div>
            <div class="justify-content-center row">
              <v-toolbar class="justify-content-center row underline_bar"></v-toolbar>
            </div>

            <div class="slider mt-5" v-if="$route.name === 'assuraf_pro_online'">
              <div class="slide-track">
                <div class="slide" v-for="assure in listeAssureurs2" :key="assure._id">
                  <img :src="require(`@/assets/img/${assure.logoUrl}`)" :alt="assure.logoTitle">
                </div>
                <div class="slide" v-for="assure in listeAssureurs2" :key="'dup-' + assure._id">
                  <img :src="require(`@/assets/img/${assure.logoUrl}`)" :alt="assure.logoTitle">
                </div>
                <div class="slide" v-for="assure in listeAssureurs2" :key="'dup2-' + assure._id">
                  <img :src="require(`@/assets/img/${assure.logoUrl}`)" :alt="assure.logoTitle">
                </div>
              </div>

              <!-- Deuxième boucle -->
              <div class="slide" 
                  v-for="assure in assureursAffiches" 
                  :key="'dup-' + assure._id">
                <img :src="assure.logoUrl || assure.logo" :alt="assure.societe || assure.logoTitle">
              </div>

              <!-- Troisième boucle -->
              <div class="slide" 
                  v-for="assure in assureursAffiches" 
                  :key="'dup2-' + assure._id">
                <img :src="assure.logoUrl || assure.logo" :alt="assure.societe || assure.logoTitle">
              </div>

            </div>
          </div>

             <div class="slider mt-5" v-if="$route.name !== 'assuraf_pro_online'">
              <div class="slide-track">
                <div class="slide">
                      <img style="height: 60px; width: 180px!important;padding: 0px!important" src="../../assets/img/assureur/Logo_Sanlam_Allianz.png" alt="partenaire sanlamAllianz">
                </div>
                <div class="slide pb-5" v-for="assure in listeAssureurs" :key="assure._id">
                    <img :src="assure.logo" :alt="assure.societe">
                </div>
                 <div class="slide pb-5">
                    <img style="height: 60px; width: 180px!important;padding: 0px!important" src="../../assets/img/assureur/wafa.png" alt="partenaire wafa">
                </div>
                <div class="slide" v-for="assure in listeAssureurs" :key="'dup-' + assure._id">
                    <img :src="assure.logo" :alt="assure.societe">
                </div>
                 
                <div class="slide" v-for="assure in listeAssureurs" :key="'dup2-' + assure._id">
                    <img :src="assure.logo" :alt="assure.societe">
                </div>
              </div>
            </div>

            <!-- <div class="justify-content-center row slideassureur pt-5" style="margin-left:8%!important;margin-right:8%!important" v-if="$route.name !== 'assuraf_pro_online'">
              <div class="slider-logo">
                <div class="slide-track justify-content-center row">
                  <div class="slid_mobile" v-for="assure in listeAssureurs" :key="assure._id">
                    <img :src="assure.logo" :alt="assure.societe"></div>
                    <div class="slid_mobile">
                      <img style="height: 50px; width: 120px!important;padding: 0px!important" src="../../assets/img/assureur/wafa.png" alt="partenaire wafa">
                    </div>
                    <div class="slid_mobile">
                      <img style="height: 50px; width: 120px!important;padding: 0px!important" src="../../assets/img/assureur/Logo_Sanlam_Allianz.png" alt="partenaire sanlamAllianz">
                    </div>
                </div>
              
              </div>
            </div> -->
          </div>
        </div>
      </div>
  </v-container>
</template>

<script>
import simplebar from 'simplebar-vue';
import 'simplebar/dist/simplebar.min.css';
import Api from '../../services/Api';
import { logosAssureurs } from '../../common/ilsNousfontConfiancePro';

export default {
  name: 'partenaire_section',
  props: {
    type: {
      type: String,
      default: 'base',
      validator: v => ['pro', 'base'].includes(v)
    }
  },
  components: {
    simplebar
  },
  data: () => ({
    listeAssureurs: [],
    listeAssureurs2: logosAssureurs,
    listeLogoFromApi: [
      {societe: "AXA"},
      {societe: "NSIA"},
      {societe: "ASKIA"},
      {societe: "SUNU"},
      {societe: "CNART"},
      {societe: "ALLIANZ"},
      {societe: "SONAM GENERALE ASSURANCES"},
      {societe: "FINAFRICA"},
      {societe: "PROVIDENCE"},
      {societe: "SAAR"},
      {societe: "SANLAM"},
     // {societe: "WAFA"},
      {societe: "SONAC"},
      {societe: "ASS"},
      {societe: "AMSA"},
      {societe: "CNAAS"},
      {societe: "PA"}
    ],
    title: 'Assuraf',
    description: 'Le meilleur de l\'assurance en ligne au Sénégal. Faites votre devis, souscrivez et payez en ligne: vous êtes assuré ! Un service simple, une offre claire et complète, une expérience proactive et multicanale.',
  }),

  metaInfo() {
    return {
      title: this.title,
      meta: [{
        charset: 'utf-8'
      },
        {
          name: 'description',
          content: this.description
        }
      ]
    }
  },

  computed: {
    assureursAffiches() {
      return this.type === 'pro'
        ? this.listeAssureurs2      // logos PRO
        : this.listeAssureurs       // logos BASE (API)
    }
  },

  methods: {
    /*=================Recuperation des partenaires assureurs==============*/
    async getListePartenaire() {
      Api().get('partenaire/assureur')
          .then(response => {
            this.listeAssureurs = response.data.partenaires
            console.log(':::::::: liste des partenaires ::::::::::', this.listeAssureurs)

            const logo = this.listeAssureurs;
            const myFilter = this.listeLogoFromApi;

            const myArrayFiltered = logo.filter((el) => {
              return myFilter.some((f) => {
                return f.societe === el.societe;
              });
            });
            this.listeAssureurs = myArrayFiltered
          })
    }
  },

  mounted() {
  window.scrollTo(0, 0);  
    if (this.type === 'base') {
      this.getListePartenaire();
    }
  }
}
</script>

<style lang="less" scoped>

@import "../../assets/less/config";
@import "../../assets/css/button.css";

@keyframes header-animation {
  from {
    transform: translate3d(0, -100%, 0);
    opacity: 0;
  }
  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

.underline_bar {
  height: 4px;
  width: 150px;
  background: #ffa409;
}

.titre_for_desktop {
  color: #2b2b2b;
  font-size: 25px;
  font-weight: bold;
  text-align: center;
}

.margin {
  margin-left: 8%;
  margin-right: 8%;
}


a, button {
  outline: none;
  cursor: pointer;
}

img {
  max-width: 100%;
}

h1 {
  font-weight: 100;
  font-size: 58px;
}

h2 {
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
}

h3 {
  font-size: 20px;
  text-transform: uppercase;
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 40px;
}

h1, h2 {
  margin: 0 0 20px;
  color: #fff;
}

p {
  font-size: 14px;
}

//LOGO ASSUREUR GRISER
.slideassureur {
  img {
    filter: grayscale(2);
  }
}

.slideassureur img:hover {
  filter: grayscale(0);
}

.slide-img img {
  height: 60px;
}


.text-lg-left {
  text-align: left !important;
}



.slider-logo {
  display: flex;
  height: auto;
  margin: auto;
  overflow: hidden;
  align-items: center;
}

// .slider-logo:before {
//   position: absolute;
//   z-index: 1;
//   left: 0;
//   content: "";
//   width: 23.95%;
//   height: 110px;
//   background: linear-gradient(-90deg, hsla(0, 0%, 96.9%, 0), #f7f7f7);
// }

// .slider-logo:after {
//   position: absolute;
//   right: 0;
//   content: "";
//   width: 23.95%;
//   height: 110px;
//   background: linear-gradient(90deg, hsla(0, 0%, 96.9%, 0), hsla(0, 0%, 96.9%, 0.99) 99%);
// }

.slider-logo .slick-track {
  display: flex;
  animation: scroll 35s linear infinite;
  -webkit-animation: scroll 35s linear infinite;
  width: calc(240px * 10);
}

.slider-logo .slid {
  display: flex;
}

.slider-logo .slid img {
  width: 70px;
  height: 40px;
  padding: 1px;
  background-color: white;
  //cursor: pointer;
  margin: 15px;
  border-radius: 8px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
}

.slider-logo .slid_mobile {
  display: flex;
}

.slider-logo .slid_mobile img {
  width: 70px;
  height: 60px;
  padding: 2px;
  background-color: white;
  //cursor: pointer;
  margin: 20px;
  border-radius: 8px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
}


.col-text {
  height: 20em;
}


.col {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.col-left {
  -webkit-box-ordinal-group: -1;
  -webkit-order: -1;
  -ms-flex-order: -1;
  order: -1;
}

.col-text {
  display: flex;
  align-items: center;
  justify-content: center;
}

.Aligner-item {
  width: 70%;
  font-size: 20px
}

// :::::::::::::::::: slider
.slider{
  display: flex;
  height: auto;
  margin: auto;
  overflow: hidden;
  align-items: center;
  white-space: nowrap;
}

.slider:before{
  position: absolute;
  z-index: 1;
  left: 0;
  content: "";
  width: 10%;
  height: 110px;
  background: linear-gradient(-90deg, hsla(0, 0%, 96.9%, 0), #f7f7f7);
}

.slider:after{
  position: absolute;
  right: 0;
  content: "";
  width: 10%;
  height: 110px;
  background: linear-gradient(90deg, hsla(0, 0%, 96.9%, 0), hsla(0, 0%, 96.9%, 0.99) 99%);
}

.slider .slide-track {
  display: flex;
  animation: scroll 25s linear infinite;
  -webkit-animation: scroll 25s linear infinite;
}

.slider .slide {
  display: flex;
  flex-shrink: 0;
}

.slider .slide img{
  filter: grayscale(2);
  width: 100px;
  height: 60px;
  padding: 2px;
  background-color: white;
  margin: 20px;
  border-radius: 10px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  flex-shrink: 0;
}
.slider .slide img:hover{
  filter: grayscale(0);
}
@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-33.333%);
  }
}

</style>

